import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

//LIST OF ALL Keys Types
export const typesList = (params = '') => Http.get(`/key-types${serialize(params)}`)
export const typeCreate = (params = '') => Http.post('/key-types', params)
export const typeByID = (params = '') => Http.get(`/key-types/${params}`)
export const typeUpdate = (params = '') => Http.put(`/key-types/${params.id}`, params)
export const typeDestroy = (params = '') => Http.delete(`/key-types/${params.id}`)

// LIST ALL Keys Status
export const statusList = (params = '') => Http.get(`/key-status${serialize(params)}`)
export const statusCreate = (params = '') => Http.post('/key-status', params)
export const statusByID = (params = '') => Http.get(`/key-status/${params}`)
export const statusUpdate = (params = '') => Http.put(`/key-status/${params.id}`, params)
export const statusDestroy = (params = '') => Http.delete(`/key-status/${params.id}`)

//LIST OF ALL Keys Suppliers
export const suppliersList = (
	params = {
		per_page: 'all',
		page: 1,
		order: 'asc',
		sort: 'name',
	},
) => Http.get(`/key-suppliers${serialize(params)}`)
export const supplierCreate = (params = '') => Http.post('/key-suppliers', params)
export const supplierByID = (params = '') => Http.get(`/key-suppliers/${params}`)
export const supplierUpdate = (params = '') => Http.put(`/key-suppliers/${params.id}`, params)
export const supplierDestroy = (params = '') => Http.delete(`/key-suppliers/${params.id}`)

//LIST OF ALL Keys Suppliers Prs
export const prsList = (params = '') => Http.get(`/key-suppliers-prs${serialize(params)}`)
export const prsCreate = (params = '') => Http.post('/key-suppliers-prs', params)
export const prsByID = (params = '') => Http.get(`/key-suppliers-prs/${params}`)
export const prsUpdate = (params = '') => Http.put(`/key-suppliers-prs/${params.id}`, params)
export const prsDestroy = (params = '') => Http.delete(`/key-suppliers-prs/${params.id}`)

// KEYs
export const keyList = (params = '') => Http.get(`/keys${serialize(params)}`)
// Catálogo de lojas onde uma chave é resgatada (somente leitura).
export const storesList = () => Http.get('/key-stores')

export const newKeys = (params = '') => Http.post('/keys', params)
export const keysByID = (params = '') => Http.get(`/keys/${params}`)
export const updateKeys = (params = '') => Http.put(`/keys/${params.id}`, params)
export const deleteKeysByID = (params = '') => Http.delete(`/keys/${params.id}`)
export const broadcastKey = id => Http.post(`/keys/${id}/broadcast`)

// Users who opted in to be notified when this campaign opens.
export const followersList = (id, params = '') => Http.get(`/keys/${id}/followers${serialize(params)}`)

//LIST OF ALL Keys Items
export const itemsList = (params = '') => Http.get(`/key-items${serialize(params)}`)
export const itemCreate = (params = '') => Http.post('/key-items', params)
export const itemBulkCreate = (params = '') => Http.post('/key-items/bulk', params)
export const itemByID = (params = '') => Http.get(`/key-items/${params}`)
export const itemUpdate = (params = '') => Http.put(`/key-items/${params.id}`, params)
export const itemDestroy = (params = '') => Http.delete(`/key-items/${params.id}`)

//LIST OF ALL Keys Contents Types
export const contentsList = (params = '') => Http.get(`/content-types${serialize(params)}`)
export const contentCreate = (params = '') => Http.post('/content-types', params)
export const contentByID = (params = '') => Http.get(`/content-types/${params}`)
export const contentUpdate = (params = '') => Http.put(`/content-types/${params.id}`, params)
export const contentDestroy = (params = '') => Http.delete(`/content-types/${params.id}`)

//LIST OF ALL Keys Requests
export const requestsList = (params = '') => Http.get(`/key-requests${serialize(params)}`)
export const requestCreate = (params = '') => Http.post('/key-requests', params)
export const requestByID = (params = '') => Http.get(`/key-requests/${params}`)
export const requestUpdate = (params = '') => Http.put(`/key-requests/${params.id}`, params)
export const requestDestroy = (params = '') => Http.delete(`/key-requests/${params.id}`)
export const requestBulkUpdateStatus = (params = '') => Http.post('/key-requests/bulk-update-status', params)
// Re-fires the approval/refusal email+push for a request whose decision
// already happened — the status itself is untouched.
export const requestResendNotification = (id) => Http.post(`/key-requests/${id}/resend-notification`)

//LIST OF ALL Keys Materials

// The API returns content_types expanded as objects, but KeyMaterialRequest
// validates content_types.* as integers because the repository feeds them
// straight into sync(). Any caller that echoes a row back — the list's quick
// approve/reject spread the whole item — failed with "The content_types.0 must
// be an integer". Normalising here keeps every caller correct instead of
// relying on each one to remember the mapping.
const normalizeMaterial = params => {
	if (!params || typeof params !== 'object') return params

	if (!Array.isArray(params.content_types)) return params

	return {
		...params,
		content_types: params.content_types.map(ct => (ct && typeof ct === 'object' ? ct.id : ct)),
	}
}

export const materialsList = (params = '') => Http.get(`/key-materials${serialize(params)}`)
export const materialCreate = (params = '') => Http.post('/key-materials', normalizeMaterial(params))
export const materialByID = (params = '') => Http.get(`/key-materials/${params}`)
export const materialUpdate = (params = '') => Http.put(`/key-materials/${params.id}`, normalizeMaterial(params))
export const materialDestroy = (params = '') => Http.delete(`/key-materials/${params.id}`)

// Lifts a requester's "blocked from new key requests" gate (users.keys_blocked_at).
export const userKeyUnblock = userId => Http.delete(`/admin/users/${userId}/key-block`)
